import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VexRoutes } from 'src/@vex/interfaces/vex-route.interface';
import { DriverTripsComponent } from './driver-trips.component';

const routes: VexRoutes = [
  {
    path: '',
    component: DriverTripsComponent,
    data: {
      toolbarShadowEnabled: false
    }
  }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DriverTripsRoutingModule { }
